import { render } from "./AppBody.vue?vue&type=template&id=3cac3042"
import script from "./AppBody.vue?vue&type=script&lang=js"
export * from "./AppBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__